var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"form__field"},[_c('div',{staticClass:"form__title"},[_vm._v(_vm._s(_vm.label))])]),_c('div',{staticClass:"form__breaker"})])}
var staticRenderFns = []

export { render, staticRenderFns }